import { clone, equals } from 'ramda';

import { type IJsonQueryUnderground } from '../api-models/common/json_query';

import { setGeo } from './helpers';
import { type NonEmptyArray, type TJsonQuery } from './types';

export function setUndergrounds(
  jsonQuery: TJsonQuery,
): (...geoUndergrounds: NonEmptyArray<IJsonQueryUnderground>) => TJsonQuery {
  return (...geoUndergrounds) => {
    const geo = (jsonQuery.geo && clone(jsonQuery.geo.value)) || [];

    const nextGeo = geo.filter(g => g.type !== 'underground' || geoUndergrounds.some(u => u.id === g.id));
    const addedGeoUndegrounds = geoUndergrounds.filter(v => !geo.some(g => equals(v, g)));

    return setGeo()(jsonQuery)([...nextGeo, ...addedGeoUndegrounds]);
  };
}
